export default class Card extends HTMLElement {

  selectItem() {
    const itemSelectedEvent = new CustomEvent("update-modal", {
      detail: {
        content: `You selected the "${this.title}"`,
      },
    });

    window.dispatchEvent(itemSelectedEvent);
  }

  connectedCallback() {
    if (!this.shadowRoot) {
      const thumbnail = this.getAttribute('thumbnail');
      const title = this.getAttribute('title');
      const id = this.getAttribute('id');
      const template = document.createElement('template');
      const link = id
        ? `<a href="/product/${id}/">View Item Details</a>`
        : '';

      template.innerHTML = `
        <style>
          div {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.5rem;
            border: 1px solid #818181;
            width: fit-content;
            border-radius: 10px;
            padding: 2rem 1rem;
            height: 700px;
            justify-content: space-between;
            background-color: #fff;
            overflow-x: hidden;
          }
          button {
            background: var(--color-accent);
            color: var(--color-white);
            padding: 1rem 2rem;
            border: 0;
            font-size: 1rem;
            border-radius: 5px;
            cursor: pointer;
          }
          img {
            max-width: 500px;
            min-width: 500px;
            width: 100%;
          }
          h3 {
            font-size: 1.85rem;
          }

          @media(max-width: 768px) {
            img {
              max-width: 300px;
              min-width: 300px;
            }
            div {
              height: 500px;
            }
          }
        </style>
        <div>
          <h3>${title}</h3>
          <img src="${thumbnail}" alt="${title}" loading="lazy" width="100%">
          ${link}
          <button onclick="this.getRootNode().host.selectItem()">Preview Item Details</button>
        </div>
      `;
      this.attachShadow({ mode: 'open' });
      this.shadowRoot.appendChild(template.content.cloneNode(true));
    }
  }
}

customElements.define('app-card', Card);